import EvaluationStatusCircle from "../States/EvaluationStatesCircle";

interface IEvaluationTypeIndicator {
    status: number | null;
    size: number;
    label: string;
    isSelected: boolean;
    handleClick: () => void;
    showStatus?: boolean;
    numberOfIndicators?: number;
}

const EvaluationTypeIndicator = ({
    status,
    size,
    label,
    isSelected,
    handleClick,
    showStatus = true,
    numberOfIndicators
}: IEvaluationTypeIndicator) => {
    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleClick();
        }
    };

    return (
        <button
            type='button'
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            tabIndex={0}
            aria-pressed={isSelected}
            aria-label={`Tipo de indicador: ${label}`}
            className={`relative rounded-sm cursor-pointer w-full h-10 md:h-14 
              focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-10 focus-visible:ring-offset-2
              ${isSelected
                    ? "bg-brand-green-30 text-primary-100 flex items-center justify-center"
                    : "bg-system-light-10 text-brand-green-20 text-primary-40 btn "
                }`}
        >
            {showStatus &&
                <div className="absolute top-[-0.75rem] md:top-[-0.50rem] rounded-full border-[3px] border-primary-100 shrink-0 overflow-hidden bg-primary-100 flex justify-center items-center shadow-custom-dual">
                    <EvaluationStatusCircle status={status} size={size} />
                </div>
            }
            <div className="flex flex-col items-center justify-center">
                <span className="text-lsmall md:text-llarge">{label}</span>
                {numberOfIndicators != null && (
                    <span className={`text-bxsmall md:text-bsmall ${isSelected ? 'text-brand-green-9' : 'text-brand-green-15'} `}>{numberOfIndicators} Indicadores</span>
                )}
            </div>
        </button>
    );
};

export default EvaluationTypeIndicator;